import styled from "@emotion/styled";
import { Button, DatePicker, Input, Space } from "antd";
import dayjs from "dayjs";
import { FC, SetStateAction, useEffect, useState } from "react";

interface SearchOrderFormProps {
    searchInput: string;
    setSearchInput:  (value: SetStateAction<string>) => void;
    dateInput: string;
    setDateInput:  (value: SetStateAction<string>) => void;
}

const SearchOrderForm:FC<SearchOrderFormProps> = (
{ 
searchInput,
setSearchInput,
dateInput,
setDateInput 
}) => { 
    const [tempSearchInput, setTempSearchInput] = useState<string>(searchInput);
    const [tempDateInput, setTempDateInput] = useState<string>(dateInput);

    useEffect(()=> {
        setTempSearchInput(searchInput);
    }, [searchInput])

    useEffect(() => {
        setTempDateInput(dateInput);
    }, [dateInput]);

    const handleSearch = () => {
        setSearchInput(tempSearchInput);
        setDateInput(tempDateInput);
    };
    
    const handleClear = () => {
        setTempSearchInput('');
        setTempDateInput('');
        setSearchInput('');
        setDateInput('');
    };  

    const handleDateChange = (date: any) => {
        setTempDateInput(date ? dayjs(date).format('YYYY-MM-DD') : '');
    };
    return (
    <ButtonWrapper>
        <Space.Compact>
        <Input
            style={{ height: '32px' }}
            placeholder="ค้นหาคำสั่งซื้อ เบอร์ ชื่อ"
            value={tempSearchInput}
            onChange={(e) => setTempSearchInput(e.target.value)}
        />
        <DatePicker
            style={{width:'100%'}}
            placeholder="วันที่คำสั่งซื้อ"
            format={"DD/M/YYYY"}
            placement="topRight"
            showToday={true}
            inputReadOnly={true}
            value={tempDateInput ? dayjs(tempDateInput) : null}
            onChange={handleDateChange}
        />
        <Button type="default" onClick={handleSearch}>ค้นหา</Button>
        {(tempSearchInput || tempDateInput) && (
            <Button type="default" onClick={handleClear}>X</Button>
        )}
        </Space.Compact>
      </ButtonWrapper>
    )
}

export default SearchOrderForm;

const ButtonWrapper = styled.div`
display: flex;
flex-direction: row;
width: 100%;
height: 100%;
`;